import React, { useEffect, useState } from 'react';
import { FormControl, Select, InputLabel, MenuItem, Grid2, Box, Typography } from '@mui/material';
import ClientWiseJobReport from '../report/clientWiseJobReport';
import JobStatusReport from '../report/jobStatusReport';
import JobCompletionReport from '../report/jobCompletionReport';
import MissedExDateReport from '../report/missedExDateReport';
import '../../css/Reports.css';
import EmpEfficiencyReport from './empEfficiencyReport';
import EmpJobTaskReport from './empJobTaskReport';
import { useAuth } from '../../services/authentication/authContext';
import { jwtDecode } from 'jwt-decode';
import EmpWiseJobReport from './empWiseJobReport';
import EmpExtraTaskReport from './empExtraTaskReport';
import JobWiseReport from './jobWiseReport';
import PageHeader from '../ui/PageHeader';

const reportLabels = {
    clientWiseJobReport: "Client Wise Job Report",
    jobStatusReport: "Job Status Report",
    completedJobReport: "Job Completion Report",
    missedExDateReport: "Missed Expected Date Report",
    empEfficiencyReport: "Employee Efficiency Report",
    empExtraTaskReport: "Employee Extra Task Report",
    empWiseJobReport: "Employee Wise Job Report",
    jobWiseReport: "Job Wise Report",
    empJobTaskReport: "Employee Day Wise Report"
};

const Reports = () => {
    const [selectedReport, setSelectedReport] = useState('clientWiseJobReport');
    const [roles, setRoles] = useState([]);
    const { accessToken } = useAuth();
    const isAdmin = Array.isArray(roles) && (roles.includes('ADMIN') || roles.includes('SUPER_ADMIN'));
    const isSubAdmin = Array.isArray(roles) && roles.includes('SUB_ADMIN');
    const isTeamLeader = Array.isArray(roles) && roles.includes('MANAGE_JOBS');
    const isTeamMember = Array.isArray(roles) && roles.includes('MANAGE_TASKS');
    //const isTeamMember = Array.isArray(roles) && roles.includes('MANAGE_TASKS') && !roles.includes('MANAGE_JOBS');

    useEffect(() => {
        if (accessToken) {
            const decodedToken = jwtDecode(accessToken);
            let extractedRoles = [];

            if (Array.isArray(decodedToken.roles)) {
                extractedRoles = decodedToken.roles;
            } else if (typeof decodedToken.roles === "string") {
                extractedRoles = decodedToken.roles.split(",").map(role => role.trim());
            }

            setRoles(extractedRoles);
        }
    }, [accessToken]);

    const reportUrls = {
        clientWiseJobReport: <ClientWiseJobReport showHeader={false} />,
        jobStatusReport: <JobStatusReport showHeader={false} />,
        completedJobReport: <JobCompletionReport showHeader={false} />,
        missedExDateReport: <MissedExDateReport showHeader={false} />,
        empEfficiencyReport: <EmpEfficiencyReport showHeader={false} />,
        empJobTaskReport: <EmpJobTaskReport showHeader={false} />,
        empWiseJobReport: <EmpWiseJobReport showHeader={false} />,
        jobWiseReport: <JobWiseReport showHeader={false} />,
        empExtraTaskReport: <EmpExtraTaskReport showHeader={false} />
    };

    const handleReportChange = (event) => {
        setSelectedReport(event.target.value);
    };

    return (
        <div className="reports-container">
            <PageHeader title="Reports" />

            <Grid2 container justifyContent="center" alignItems="center" spacing={2} className="dropdown-container">
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <FormControl fullWidth>
                        <InputLabel>Report Type</InputLabel>
                        <Select
                            value={selectedReport}
                            required
                            onChange={handleReportChange}
                            label="Report Type"
                        >
                            {(isAdmin || isSubAdmin || isTeamLeader || isTeamMember) && <MenuItem value="clientWiseJobReport">Client Wise Job Report</MenuItem>}
                            {(isAdmin || isSubAdmin || isTeamLeader) && <MenuItem value="jobStatusReport">Job Status Report</MenuItem>}
                            {(isAdmin || isTeamLeader) && <MenuItem value="completedJobReport">Job Completion Report</MenuItem>}
                            {(isAdmin || isSubAdmin) && <MenuItem value="missedExDateReport">Missed Expected Date Report</MenuItem>}
                            {isAdmin && <MenuItem value="empEfficiencyReport">Employee Efficiency Report</MenuItem>}
                            {(isAdmin || isSubAdmin) && <MenuItem value="empExtraTaskReport">Employee Extra Task Report</MenuItem>}
                            {isTeamLeader && <MenuItem value="empWiseJobReport">Employee Wise Job Report</MenuItem>}
                            {(isAdmin || isTeamLeader || isTeamMember) && <MenuItem value="jobWiseReport">Job Wise Report</MenuItem>}
                            {(isAdmin || isTeamLeader || isTeamMember) && <MenuItem value="empJobTaskReport">Employee Day Wise Report</MenuItem>}
                        </Select>
                    </FormControl>
                </Grid2>
            </Grid2>

            {/* Main content area that renders the selected report */}
            <Box className="report-box">
                {reportUrls[selectedReport]}
            </Box>
        </div>
    );
};

export default Reports;
